var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSatelitte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.9,110.78l11.19,11.6m-7.78-20.14a12.24,12.24,0,0,1-3.41,8.54,11.4,11.4,0,0,1-8.26,3.55,12.1,12.1,0,1,1,11.67-12.09Zm-37.6,67.14L164.54,75.3s26.38,49.27-6.92,84.23C157.62,159.53,120.77,198.05,73.71,169.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.76,103.1a34,34,0,0,1,34.39-33.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.14,104.56A60.14,60.14,0,0,1,101.1,46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatelitte);
export default __webpack_public_path__ + "static/media/SATELITTE.9bbcb3949496a5ca69dd41a51c381eda.svg";
export { ForwardRef as ReactComponent };